<!--<div class="align" [formGroup]="formGroup">
     <p-dropdown [options]="dataBind" [formControlName]="controlName" [filter]="true" filterBy="label,value" (onChange)="onChangeValue($event)" (onBlur)="onChangeValue($event)"></p-dropdown> 
     <div class="error-msg" *ngIf="blnShowError && errorMessage &&  errorMessage.length > 0">
        <div class="text-danger">
               {{ errorMessage }}
        </div>
    </div>
</div>

<div class="dropDown" [formGroup]="formGroup">
    <button #stateRef class="dropbtn" (click)="showData()" (focus)="showDropDown()" (keyup)="onFilterValues($event)" > {{ labelName}} </button>
    <div *ngIf="blnShowData" class="dropdown-content">
        <div *ngFor="let item of displayLs">
            <span (click)="stateSelected(item)">{{ item.label }}</span>
    </div>
    </div>
</div>
<div class="side-chevron-container" (click)="showData()"><i [ngClass]="{ 'down' : !blnShowData, up: blnShowData }" class="arrow"></i></div>
<div class="error-msg" *ngIf="blnShowError && errorMessage &&  errorMessage.length > 0">
    <div class="text-danger">
           {{ errorMessage }}
    </div>
</div>
-->
<div class="select" [formGroup]="formGroup">
    <select [formControlName]="controlName" (change)="onSelect($event)">
        <option *ngFor="let item of displayLs" [value]="item.value">
            {{ item.label}}
          </option>
    </select>
   
  </div>
  <div class="error-msg" *ngIf="blnShowError && errorMessage &&  errorMessage.length > 0">
    <div class="text-danger">
           {{ errorMessage }}
    </div>
</div>